import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { getVehiculosPorTenant } from '../../helpers/api_helper';

const useObtenerVehiculosPorTenant = (limit = 100, refresh = 0) => {
    const [vehiculos, setVehiculos] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const tenantId = useSelector((state) => state.Context.tenantId);

    useEffect(() => {
        const fetchVehiculos = async () => {
            if (!tenantId) return;

            setLoading(true);
            setError(null);
            try {
                const response = await getVehiculosPorTenant({
                    tenantId, limit
                });
                console.log('Response from API for vehiculos by tenant:', response);
                setVehiculos(response.records);
            } catch (err) {
                const errorMessage = `Failed to fetch vehiculos: ${err.message || 'Unknown error'}`;
                setError(errorMessage);
                console.error(errorMessage);
                setVehiculos(null);
            } finally {
                setLoading(false);
            }
        };

        fetchVehiculos();
    }, [tenantId, limit, refresh]);

    return { vehiculos, loading, error };
};

export default useObtenerVehiculosPorTenant;